import React, { useState } from "react";
import style from "../BulkUploadTabs.module.css";
import { FaCloudArrowUp, FaFileZipper } from "react-icons/fa6";
import { IoClose } from "react-icons/io5";
import Button from "../../../component/button/Button";
import { postZip } from "../../../api/bulk-upload-api";
import { showToast } from "../../../utils/Toastify/Toastify";

const ZipUpload = () => {
  const [selectedFile, setSelectedFile] = useState(null);
  const [loading, setLoading] = useState(false);
const fileInputRef = React.useRef(null);

const handleFileChange = (e) => {
  const file = e.target.files[0];

  if (file) {
    const isZip = file.name.toLowerCase().endsWith(".zip");

    if (isZip) {
      setSelectedFile(file);
    } else {
      showToast("Please select a valid .zip file.", "error");
      e.target.value = ""; // Clear invalid file
    }
  }
};

// The chip sits inside the <label> that opens the file picker — stop the
// click there so removing a file doesn't immediately reopen the picker.
const handleRemoveFile = (e) => {
  e.preventDefault();
  e.stopPropagation();
  setSelectedFile(null);
  if (fileInputRef.current) fileInputRef.current.value = "";
};

const formatSize = (bytes) => {
  if (!bytes) return "0 KB";
  const mb = bytes / (1024 * 1024);
  return mb >= 1 ? `${mb.toFixed(2)} MB` : `${(bytes / 1024).toFixed(1)} KB`;
};

const handleUpload = async () => {
  if (!selectedFile) {
    showToast("No file selected", "error");
    return;
  }
  const formData = new FormData();
  formData.append("file", selectedFile);
  setLoading(true);
  try {
    const response = await postZip(formData);
    showToast(response?.data?.message, "success");
  } catch (error) {
    showToast("Something went wrong.", "error");
  } finally {
  setSelectedFile(null);
    if (fileInputRef.current) fileInputRef.current.value = "";
    setLoading(false);
  }
};

  return (
    <>
      <div className={style.ZipUpload}>
        <pre className={style.ZipUploadInfo}>
          <span className={style.ZipUploadInfoText}>
            Expected ZIP Structure: <br />
          </span>
          /videos/ <br />
          &nbsp;&nbsp;&nbsp;&nbsp;movie1.mp4 <br />
          &nbsp;&nbsp;&nbsp;&nbsp;movie2.mp4 <br />
          /thumbnails/ <br />
          &nbsp;&nbsp;&nbsp;&nbsp;movie1.jpg <br />
          &nbsp;&nbsp;&nbsp;&nbsp;movie2.jpg <br />
          /subtitles/ <br />
          &nbsp;&nbsp;&nbsp;&nbsp;movie1.srt <br />
          &nbsp;&nbsp;&nbsp;&nbsp;movie2.srt
        </pre>

        <div className={style.ZipUploadContainer}>
          <label htmlFor="zipUpload" className={style.uploadBox}>
            <FaCloudArrowUp className={style.cloudIcon} />
            <p className={style.uploadText}>Upload ZIP File from Computer</p>
            <p className={style.paraText}>
              Drag & Drop your file or click to browse
            </p>
            <input
              type="file"
              id="zipUpload"
              accept=".zip"
              className={style.hiddenInput}
              onChange={handleFileChange}
              ref={fileInputRef}
            />
            {selectedFile && (
              <div
                style={{ marginTop: "1rem" }}
                className={style.ZipSelectedFile}
              >
                <div className={style.ZipFileChip}>
                  <FaFileZipper className={style.ZipFileChipIcon} />
                  <div className={style.ZipFileChipInfo}>
                    <span className={style.ZipFileChipName} title={selectedFile.name}>
                      {selectedFile.name}
                    </span>
                    <span className={style.ZipFileChipSize}>{formatSize(selectedFile.size)}</span>
                  </div>
                  <button
                    type="button"
                    className={style.ZipFileChipRemove}
                    onClick={handleRemoveFile}
                    disabled={loading}
                    aria-label="Remove selected file"
                    title="Remove file"
                  >
                    <IoClose />
                  </button>
                </div>
                <div className={style.ZipFileActions}>
                  {" "}
                  <Button onClick={handleUpload} loading={loading}>
                    Upload ZIP
                  </Button>
                </div>
              </div>
            )}
          </label>
        </div>
      </div>
    </>
  );
};

export default ZipUpload;
